import {NoteEditorPlugin} from 'notebook/notes/NoteEditorTypes';

const REGISTERED_PLUGINS: Array<NoteEditorPlugin> = [];

export function registerPlugin(plugin: NoteEditorPlugin): void {
  REGISTERED_PLUGINS.push(plugin);
}

export function findPlugin(type: string): NoteEditorPlugin | undefined {
  return REGISTERED_PLUGINS.find((plugin) => plugin.type === type);
}
